import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row space-x-2" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["name", "id", "required", "checked"]

import { computed } from "vue";
import LabelBase from "@/components/Texts/LabelBase.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCheckbox',
  props: {
    name: {},
    label: {},
    id: {},
    is_required: { type: Boolean },
    modelValue: { type: Boolean },
    error: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        name: props.name,
        id: props.id,
        required: props.is_required,
        checked: props.modelValue,
        type: 'checkbox',
        onChange: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$emit(
            'update:modelValue',
            ($event.target as HTMLInputElement).checked
          )
        )),
        class: "form-checkbox h-5 w-5 text-custom-primaryBlack"
      }, null, 40, _hoisted_3)
    ]),
    (props.label)
      ? (_openBlock(), _createBlock(LabelBase, {
          key: 0,
          for: props.id,
          text: props.label,
          class: "text-white"
        }, null, 8, ["for", "text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})